"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsGreaterOrEqual = IsGreaterOrEqual;
const class_validator_1 = require("class-validator");
function IsGreaterOrEqual(property, validationOptions) {
    return function (object, propertyName) {
        (0, class_validator_1.registerDecorator)({
            name: "isGreaterOrEqualThan",
            target: object.constructor,
            propertyName,
            constraints: [property],
            options: validationOptions,
            validator: {
                validate(value, args) {
                    const [relatedPropertyName] = args.constraints;
                    const relatedValue = args.object[relatedPropertyName];
                    return value >= relatedValue;
                },
                defaultMessage(args) {
                    const [relatedPropertyName] = args.constraints;
                    return `${args.property} must be greater than or equal to ${relatedPropertyName}`;
                },
            },
        });
    };
}
//# sourceMappingURL=isGreaterOrEqualValidator.js.map